module.exports = __webpack_public_path__ + "img/ehv_logo_kl.f33839e1.png";